import React from "react"
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Chip,
  Stack,
} from "@mui/material"
import DoneIcon from "@mui/icons-material/Done"
import Helpers from "../../utils/Helpers"

const PermissionsModal = ({ open, onClose, permissions, isPending }) => {
  return (
    <Dialog open={open}>
      <DialogTitle textAlign="center">Permissions</DialogTitle>
      <DialogContent dividers>
        <Stack
          spacing={{ xs: 1, sm: 2 }}
          direction="row"
          useFlexGap
          flexWrap="wrap"
          alignItems="center"
        >
          {permissions?.map((p) => (
            <Chip
              key={p.permission}
              label={Helpers.underscorePermFormat(p.permission)}
              deleteIcon={<DoneIcon />}
            />
          ))}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: "1.25rem" }}>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  )
}
export default PermissionsModal
